import PortalVue, { Wormhole } from "portal-vue";
import Vue from "vue";

Wormhole.trackInstances = false;
Vue.use(PortalVue);
